export default "__VITE_ASSET___9Ub7Z8N__"